/**
 * Fills a canvas with a solid background color.
 */
export class SolidBackground {
  constructor (fillStyle) {
    this._fillStyle = fillStyle;
  }

  draw (surface) {
    const ctx = surface.ctx;

    ctx.fillStyle = this._fillStyle;
    ctx.fillRect(0, 0, surface.width, surface.height);
  }
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/snapshot/drawing/shapes/SolidBackground.js